/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Noevents2Inputs */

const en_coinvestments_audit_noevents2 = /** @type {(inputs: Coinvestments_Audit_Noevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit events found`)
};

/**
* | output |
* | --- |
* | "No audit events found" |
*
* @param {Coinvestments_Audit_Noevents2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_noevents2 = /** @type {((inputs?: Coinvestments_Audit_Noevents2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Noevents2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_noevents2(inputs)
});
export { coinvestments_audit_noevents2 as "coInvestments_audit_noEvents" }